module.exports = __webpack_public_path__ + "img/code_bg.8e67bab4.png";